import { useEffect, useState } from 'react';
import { useTheme } from '@/components/theme-provider';

/**
 * Returns the resolved theme ('light' or 'dark'), handling the 'system' option by
 * reading the system preference via `matchMedia` and reacting to OS-level changes.
 */
export function useResolvedTheme(): 'light' | 'dark' {
  const { theme } = useTheme();
  const [systemDark, setSystemDark] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  useEffect(() => {
    if (theme !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => setSystemDark(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [theme]);

  if (theme === 'system') return systemDark ? 'dark' : 'light';
  return theme;
}
